"use client";

import { c as _c } from "react/compiler-runtime";
import type { BannerProps } from "./general-banner.types";
import { BannerSingle } from "./banner-single.component";
import { BannerMulti } from "./banner-multi.component";
export function Banner(t0) {
  const $ = _c(8);
  const {
    banners,
    variant,
    className
  } = t0;
  if (!banners || banners.length === 0) {
    return null;
  }
  if (banners.length >= 2) {
    let t1;
    if ($[0] !== banners || $[1] !== className || $[2] !== variant) {
      t1 = <BannerMulti banners={banners} variant={variant} className={className} />;
      $[0] = banners;
      $[1] = className;
      $[2] = variant;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== banners[0] || $[5] !== className || $[6] !== variant) {
    t1 = <BannerSingle item={banners[0]} variant={variant} className={className} />;
    $[4] = banners[0];
    $[5] = className;
    $[6] = variant;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}